module.exports = __webpack_public_path__ + "media/images/solicitud/usuario-73a655c5af95b07cbdda9f15414e3f6c.svg";